<template>
  <div class="pa-story-title" :class="storyTitleClass">
    <template v-if="storyLogo !== null">
      <component :is="storyLogo"></component>
    </template>
    <template v-else>
      <p>{{storyData.title}}</p>
    </template>
  </div>
</template>

<script>
import StoryProrogueLogo  from '@/components/Parts/StoryTitleLogo/Images/Prorogue.svg?inlineN'
import StoryFirstLogo     from '@/components/Parts/StoryTitleLogo/Images/First.svg?inlineN'

export default {
  props      : ['storyData'],

  components : {
    StoryProrogueLogo,
    StoryFirstLogo
  },

  data(){
    return {
      storyLogo       : null,

      logoList        : {
        'prorogue'  : 'StoryProrogueLogo',
        'first'     : 'StoryFirstLogo'
      },

      storyTitleClass : [],
    };
  },

  watch : {
    storyData : {
      handler(data){
        if(typeof data === 'undefined') return;
        
        if(typeof this.logoList[data.slug] !== 'undefined'){
          this.storyLogo = this.logoList[data.slug];
        }else{
          this.storyLogo = null;
        }

        this.storyTitleClass = ['pa-story-title-'+data.slug];
      },
      immediate: true
    },
  }
}
</script>

<style lang="scss">
.pa-story-title{
  &-prorogue{
    .a{
      // fill: #c2a78f;
      fill: none;
    }

    .b{
      fill: #8a5a23;
    }
  }

  &-first{
    .a{
      // fill: #c2a78f;
      fill: none;
    }

    .b{
      fill: #8a5a23;
    }
  }
}
</style>
